(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();


    const searchSummary = document.querySelector('summary.header__icon--search');

    if (searchSummary) {
      searchSummary.addEventListener('click', function () {
        const overlay = document.querySelector('.boost-pfs-search-suggestion-mobile-overlay');
        const topPanel = document.querySelector('.boost-pfs-search-suggestion-mobile-top-panel');
        const close = topPanel.querySelector('.boost-pfs-search-btn-clear-suggestion');
        const parentDetails = searchSummary.closest('details');

        // Remove the "open" attribute from the parent <details> if it exists
        if (parentDetails && parentDetails.hasAttribute('open')) {
          parentDetails.removeAttribute('open');
        }

        if (overlay) {
          overlay.style.display = 'block';
        }

        if (topPanel) {
          topPanel.style.display = 'block';
        }
        if(close){
          close.style.display= 'none';
        }
        
      });
    }
      
      
    }

    connectedCallback() {
      // this.header = document.getElementById('shopify-section-header');
      this.header = document.querySelector('.section-header');
      this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains( "header-wrapper--border-bottom") ? 1 : 0;
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      if(document.body.classList.contains("template-index")){
        this.Categories()
      }

      setTimeout(() => {
        document.documentElement.style.setProperty("--header-bottom-position",`${parseInt(this.header.clientHeight - this.borderOffset)}px`);
      }, 100);

    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.top) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.top) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      if(document.querySelector('.onLoadclick')){
        document.querySelector('.onLoadclick').parentElement.removeAttribute('open');
        document.querySelector('#MainContent').style.paddingTop = '0px';
      }
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-sticky');
      if(document.querySelector('.onLoadclick')){
        document.querySelector('.onLoadclick').parentElement.setAttribute('open', 'true');
        document.querySelector('#MainContent').style.paddingTop = 'var(--megamenu-offset)';
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    Categories(){
      var megaMenuContent = document.querySelector("#MegaMenu-Content-1");
      if (!megaMenuContent) return;
      document.querySelector("#MainContent").style.paddingTop = megaMenuContent.clientHeight + 'px';
      document.documentElement.style.setProperty("--megamenu-offset", megaMenuContent.clientHeight + 'px');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
